import React, { useEffect, useState } from 'react'
import { fetchByOdata } from './action'
import {Render} from '../../components/Render/Render'
import {Snackbar, Box} from '@material-ui/core';
import AlertHelper from '../../components/Alert'
import { Button, Modal } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import { TrainingTable } from '../../components/Training'
import { Typography } from '@material-ui/core'

export default function ExternalmaterialPdf(props) {
    const [material, setMaterial] = useState({name:'',url:'', system:''});
    const [loading, setLoading] = useState(true);
    const mediatoken = localStorage.getItem('mediatoken');
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
      };

    const [snackBar, setSnackBar] = useState({
        isOpen: false,
        message: '',
        vertical: 'top',
        horizontal: 'right',
        type: 'error'
    });

    const handleCloseSnackbar = async => {
        setTimeout(function () {
            setSnackBar({ ...snackBar, isOpen: false, message: '' })
        }, 3000);
    }

    var array = []
    var extensao = ''
    var teste

    useEffect(() => {
        getData();
        async function getData() {
            try{
                teste = await fetchByOdata(props.match.params.id);
            }
            catch{
                setSnackBar({ ...snackBar, isOpen: true, message: 'Erro na Requisição' })
            }
            const response = teste
            response.data.content = response.data.url
            array = response.data.url.split('.')
            extensao = array[array.length - 1]
                
            switch (extensao){
                case 'mp4':
                    response.data.stepTypeId = 1
                    break;
                case'pdf':
                    response.data.stepTypeId = 4
                    break;
                case'docx':
                    response.data.stepTypeId = 5
                    break;
                case'doc':
                    response.data.stepTypeId = 6
                    break;
                case'xls':
                    response.data.stepTypeId = 7
                    break;
                case'xlsx':
                    response.data.stepTypeId = 8
                    break;
                case'ppt':
                    response.data.stepTypeId = 9
                    break;
                case'pptx':
                    response.data.stepTypeId = 10
                    break;
                default:
                    response.data.stepTypeId = 0
                    break;
            }  
            setMaterial(response.data)
            setLoading(false)      
        }      
    }, [])

    return (
        <>
            {loading? 'carregando...':
            <>
            <center><h1 style={{font: '50px Arial, sans-serif'}}>{material.name}</h1></center>
                    <center><h1 style={{ font: '50px Arial, sans-serif' }}>{material.system}</h1></center>
                    <br></br>
                    <br></br>
                    <center>
                        {
                            material.stepTypeId != 0 ?
                        <Render step={material} standardType='lpp' />
                        :
                        <Button variant="contained" onClick={handleOpen} color="secondary" size="large">Acessar Treinamento</Button>
                        }
                    </center>
                    <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                                Este é um documento presente em DMS e por isso meu acesso é SOMENTE LEITURA. Estou ciente de que NÃO É PERMITIDA a impressão deste documento.
                        </Typography>
                        <a target='blank' href={material.url} style={{display:"flex", alignItems: "center", justifyContent: "center", marginTop: "10px"}}>
                             <Button variant="contained" color="secondary" size="large" endIcon={<SendIcon />}>Ok</Button>
                         </a>
                        </Box>
                    </Modal>
                     
                    <br></br>
                    <div className="mt-2">
                        <div className="mt-2 d-flex">
                            <Typography variant="h3">Colaboradores Treinados</Typography>
                        </div>
                        <div className="mb-4">
                            <TrainingTable editTraining={false} externalMaterial={material} />
                        </div>
                    </div>

            <Snackbar
            open={snackBar.isOpen}
            anchorOrigin={{ vertical: snackBar.vertical, horizontal: snackBar.horizontal }}
            key={snackBar.vertical + snackBar.horizontal}
            autoHideDuration={1000}
            onClose={(e) => handleCloseSnackbar(e)}
        >
            <AlertHelper onClose={handleCloseSnackbar} severity={snackBar.type}>
                {snackBar.message}
            </AlertHelper>
        </Snackbar>

            </>
            }
        </>
    )
}

